module.exports = __webpack_public_path__ + "assets/img/visual2.8ac1ed99.png";